import MVPDCore from "components/livetv/MVPDCore";
import TVProviderSelectionMessageBox from "components/messageBoxes/TVProviderSelectionLiveTVMessage";
import MVPDVerifiedMessageBox from "components/messageBoxes/MVPDVerifiedMessage";
import AuthModal from 'components/modals/AuthModal';
import LiveTVTrackingService from "services/LiveTVTrackingService";
import {getCookie, setCookie,removeCookie} from "helpers/VanillaCookie";
import { getMVPDAuthZObj } from "helpers/mvpdStorage";

export default class TVProviderSelector {

    constructor() {
        this.parentContainer = document.querySelector('#live-tv-providers .tv__provider__selector__container');
        this.serverData = JSON.parse(document.querySelector('#app-config').innerHTML);

        this.providers = null;

        this.mvpdCore = new MVPDCore({
            wrapper: this.parentContainer,
            serverData: this.serverData,
        });

        this.TVProviderSelectorMessageBox = null;
        this.mvpdVerifiedMessageBox = null;
        this.mvpdAuthForm = new AuthModal();

        this.tracking = new LiveTVTrackingService();

        this.__setupEventHandlers();
    }

    /**
     * @private
     */
    __setupEventHandlers() {
        this.mvpdCore.onProvidersAvailable((providers) => {
            this.__onProvidersAvailableHandler(providers);
        });

        this.mvpdCore.onCreateIFrame((width, height) => {
            this.__onCreateIFrameHandler(width, height);
        });

        this.mvpdCore.onNotLoggedIn(() => {
            this.__onNotLoggedInHandler();
        });

        this.mvpdCore.onLoggedIn(() => {
            this.__onLoggedInHandler();
        });
    }

    /**
     * @param providers
     * @private
     */
    __onProvidersAvailableHandler(providers) {
        this.providers = providers;

        this.__clearContainer();

        let copy = {
            title: this.mvpdCore.messages.getMessage('lt_tv_provider_selector_title')
        };

        this.TVProviderSelectorMessageBox = new TVProviderSelectionMessageBox(this.parentContainer, providers, copy, this.mvpdCore.imageHost);

        this.TVProviderSelectorMessageBox.onProviderSelected((providerID) => {
            let provider = this.providers.filter(p => p.providerID === providerID).pop();

            if (provider) {
                this.mvpdCore.setSelectedProvider(provider);
            }
        });

        this.TVProviderSelectorMessageBox.show();
    }

    /**
     * @param width
     * @param height
     * @private
     */
    __onCreateIFrameHandler(width, height) {
        let ifrmNode = document.createElement('IFRAME');

        ifrmNode.style.width = width + 'px';
        ifrmNode.style.height = height + 'px';
        ifrmNode.name = 'mvpdframe';
        ifrmNode.id = 'mvpdframe';
        ifrmNode.style.frameborder = '0';
        ifrmNode.style.border = '0';

        let div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.top = '50px';
        div.style.left = '50%';
        div.style.zIndex = '98';
        div.style.marginLeft = "-" + width / 2 + "px";

        div.appendChild(ifrmNode);

        this.parentContainer.appendChild(div);
    }

    /**
     * After verifying token success, and not logged in, show signup form
     * @private
     */
    async __onNotLoggedInHandler() {
        let mvpdAuthZObj = getMVPDAuthZObj()

        $('#provider__logout').click(function () {
            mvpdAuthZObj.regLater = false;
            setCookie('mvpd_authz', JSON.stringify(mvpdAuthZObj), {
                path: '/',
                domain: '.cbs.com'
            });
        });

        return this.__showMVPDVerifiedScreen(mvpdAuthZObj, false);
    }

    /**
     * After verifying token success, and user is logged in
     * @returns {Promise<void>}
     * @private
     */
    async __onLoggedInHandler() {
        if (!CBS.Registry.Features.mvpd) {
            window.location.assign(this.serverData?.flow?.destinationUrl ?? '/live-tv/stream/');
            return;
        }

        let mvpdAuthZObj = getMVPDAuthZObj()

        return this.__showMVPDVerifiedScreen(mvpdAuthZObj, true);
    }

    async __showMVPDVerifiedScreen(mvpdAuthZObj, isLoggedIn) {
        if (mvpdAuthZObj) {
            if (mvpdAuthZObj.regLater && CBS.Registry.user.id) {
                window.location.assign('/live-tv/stream/');

                return;
            } else {
                if (await this.mvpdCore.checkMVPDIsBound()) {
                    this.mvpdCore.loginMVPDAuthZUser((res) => {
                        this.__displayMVPDVerifiedMessageBox(true, res.data.isGhost)
                    })
                } else {
                    this.__displayMVPDVerifiedMessageBox(false, !isLoggedIn)
                }
            }
        } else {
            this.__displayMVPDVerifiedMessageBox(false, !isLoggedIn)
        }
    }

    __displayMVPDVerifiedMessageBox(didLoginMVPDAuthZUser = false, isAnonOrGhost = true) {
        let mvpdAuthZObj = getMVPDAuthZObj()
        let bypassReg = false;

        if (mvpdAuthZObj) {
            bypassReg = mvpdAuthZObj.bypassReg;
        }

        let startWatch = (destination) => {
            if (mvpdAuthZObj) {
                mvpdAuthZObj.regLater = true;

                setCookie('mvpd_authz', JSON.stringify(mvpdAuthZObj), {
                    path: '/',
                    domain: '.cbs.com'
                })

                if (didLoginMVPDAuthZUser) {
                    window.location.assign(destination)
                } else {
                    this.mvpdCore.loginMVPDAuthZUser((res) => {
                        window.location.assign(destination)
                    }, (err) => {
                    })
                }
            }
        }

        this.mvpdVerifiedMessageBox = new MVPDVerifiedMessageBox(this.parentContainer, {
            title: this.mvpdCore.messages.getMessage('lt_mvpd_verified_title'),
            list: this.mvpdCore.messages.getMessage('lt_mvpd_verified_desc_list'),
            bypassReg: bypassReg,
            isAnonOrGhost: isAnonOrGhost,
            lt_mvpd_verified_heading: this.mvpdCore.messages.getMessage('lt_mvpd_verified_heading'),
            lt_mvpd_verified_sub_heading: this.mvpdCore.messages.getMessage('lt_mvpd_verified_sub_heading'),
            lt_mvpd_verified_text: this.mvpdCore.messages.getMessage('lt_mvpd_verified_text'),
            lt_mvpd_verified_watch_cta: this.mvpdCore.messages.getMessage('lt_mvpd_verified_watch_cta'),
            lt_mvpd_verified_sign_up_cta: this.mvpdCore.messages.getMessage('lt_mvpd_verified_sign_up_cta'),
            lt_mvpd_verified_sign_in_cta: this.mvpdCore.messages.getMessage('lt_mvpd_verified_sign_in_cta'),
            lt_mvpd_verified_sign_in_text: this.mvpdCore.messages.getMessage('lt_mvpd_verified_sign_in_text'),
            lt_mvpd_verified_register_later: this.mvpdCore.messages.getMessage('lt_mvpd_verified_register_later'),
            lt_mvpd_verified_legal_text: this.mvpdCore.messages.getMessage('lt_mvpd_verified_legal_text'),
        });

        //get provider icon
        this.tracking.__getProvider()
            .then((provider) => {
                if (provider) {
                    this.mvpdVerifiedMessageBox.displayProviderIcon(provider);
                }
            });

        this.mvpdVerifiedMessageBox.onSignInClicked(() => {
            this.tracking.trackSignInModal();
            this.mvpdAuthForm.setDefaultAction('sign-in');
            this.mvpdAuthForm.show();
        });

        this.mvpdVerifiedMessageBox.onSignUpClicked(() => {
            this.tracking.trackSignUpModal();
            this.mvpdAuthForm.setDefaultAction('sign-up');
            this.mvpdAuthForm.show();
        });

        this.mvpdVerifiedMessageBox.onRegLaterClicked(() => {
            startWatch(this.__getStartWatchingDestination());
        });

        this.mvpdVerifiedMessageBox.onStartWatchClicked(() => {
            startWatch(this.__getStartWatchingDestination());
        });

        this.mvpdVerifiedMessageBox.show();
    }

    __getStartWatchingDestination() {
        const liveEventDestinationIfAny = sessionStorage.getItem('KSLivePlayer:redirectAfterMvpdLogin');

        // validate if liveEventDestinationIfAny is a valid url
        if (liveEventDestinationIfAny) {
            try {
                const url = new URL(liveEventDestinationIfAny, window.location.origin);
                // Ensure the URL is within the same origin for security
                if (url.origin === window.location.origin) {
                    // clear after use
                    sessionStorage.setItem('KSLivePlayer:redirectAfterMvpdLogin', '');
                    return liveEventDestinationIfAny;
                }
            } catch (e) {
                // Invalid URL, ignore and use default destination
                console.error('KSLiveEvent: invalid url ' + liveEventDestinationIfAny, e);
            }
        }

        return this.serverData?.flow?.destinationUrl ?? '/live-tv/stream/';
    }

    /**
     * @private
     */
    __clearContainer() {
        this.parentContainer.innerHTML = '';
    }
}
